import React from "react"
import { Box } from "@material-ui/core"
import { Page, PageSection, SearchBar } from "src/components"
import SuspenseWrapper from "src/components/layout/SuspenseWrapper"
import BrokersDataTable from "./components/BrokersDataTable"

const BrokerAdminPage = () => {
  const [addNewItem, setAddNewItem] = React.useState(false)

  return (
    <>
      <Page title="Broker Management">
        <SearchBar
          name="Broker"
          addNewItem={() => setAddNewItem(true)}
          mb={3}
        />
        <PageSection>
          <Box sx={{ pt: 3 }}>
            <SuspenseWrapper>
              <BrokersDataTable
                addNewItem={addNewItem}
                onAddItemClose={() => setAddNewItem(false)}
              />
            </SuspenseWrapper>
          </Box>
        </PageSection>
      </Page>
    </>
  )
}

BrokerAdminPage.propTypes = {}

export default BrokerAdminPage
